/**
 * Represents the different types of roles for a user.
 * @deprecated use swagger doc version instead
 */
export enum RoleType {
  Admin = "admin",
  Job = "job",
  ViewOnly = "view-only",
}
